/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RefundPaymentDetailsViewModel } from './refundPaymentDetailsViewModel';

export interface AddRefundViewModel {
  datasetId?: string;
  payeeId?: string | null;
  payeeType?: string | null;
  payeeName?: string | null;
  payeeAddress1?: string | null;
  payeeAddress2?: string | null;
  payeeCity?: string | null;
  payeeState?: string | null;
  payeeZip?: string | null;
  payeeCountry?: string | null;
  amount?: number;
  notes?: string | null;
  memo?: string | null;
  refundStatus?: string | null;
  details?: Array<RefundPaymentDetailsViewModel> | null;
}
